import React from 'react';
import TimeAgo from 'react-timeago';
import { formatter } from '../constants/formatter';
import { v4 as uuidv4 } from 'uuid';
import { Table } from '../components';
import * as ROUTES from '../constants/routes';
import { siparisTuruneGoreIconGetir } from '../helpers';
import { SIPARIS_TUR } from '../constants/siparis-tur';

function DashboardTableContainer({ data: response }) {
  const { teslimatBekleyenSiparisler } = response.data;

  const handleSiparisClick = (e, id) => {
    e.stopPropagation();
  };
  return (
    <>
      {teslimatBekleyenSiparisler.map(
        ({
          musteri_ad_soyad,
          cep_telefonu,
          teslimat_adresi,
          bayi_adi,
          arac_plaka,
          toplam_tutar,
          urun_sayisi,
          siparis_id,
          siparis_tur_id,
          siparis_tarihi,
          siparis_tarihi_format,
          teslimat_turu,
          teslimat_tur_id,
          teslimat_tarihi,
        }) => (
          <Table.Row key={uuidv4()}>
            <Table.RowLink
              onClick={(e) => handleSiparisClick(e, siparis_id)}
              to={`${ROUTES.SIPARIS_DETAY}/${siparis_id}`}
            >
              <Table.Data verticalAlign='top'>
                <Table.IconContainer
                  variant={
                    siparis_tur_id === SIPARIS_TUR.CALL_CENTER ? 'purple' : ''
                  }
                >
                  {siparisTuruneGoreIconGetir(siparis_tur_id)}
                </Table.IconContainer>
              </Table.Data>
              <Table.Data>
                <Table.Text>{musteri_ad_soyad}</Table.Text>
                <Table.TextSmall>{cep_telefonu}</Table.TextSmall>
              </Table.Data>
              <Table.Data>
                <Table.Text>{teslimat_adresi[0]}</Table.Text>
                <Table.TextSmall>
                  {`${teslimat_adresi[1]} / ${teslimat_adresi[2]}`}
                </Table.TextSmall>
              </Table.Data>
              <Table.Data>
                <Table.Text>{bayi_adi}</Table.Text>
                <Table.TextSmall>{arac_plaka}</Table.TextSmall>
              </Table.Data>
              <Table.Data>
                <Table.Price>{toplam_tutar}</Table.Price>
                <Table.TextSmall>{urun_sayisi} Adet</Table.TextSmall>
              </Table.Data>
              <Table.Data verticalAlign='baseline'>
                <Table.Text>
                  <TimeAgo
                    date={siparis_tarihi}
                    formatter={formatter}
                    title={siparis_tarihi_format}
                  />
                </Table.Text>
              </Table.Data>
              <Table.Data>
                <Table.Order kind={teslimat_tur_id}>
                  {teslimat_turu}
                </Table.Order>
                <Table.Text>{teslimat_tarihi}</Table.Text>
              </Table.Data>
            </Table.RowLink>
          </Table.Row>
        )
      )}
    </>
  );
}

export default DashboardTableContainer;
